module.exports = __webpack_public_path__ + "tf.06bda6c0bf87bfffd703.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tf.svg
// module chunks = styles